import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import DownloaderFormFont from './DownloaderFormFont'
import DownloaderFormStyle from './DownloaderFormStyle'
import type { DownloaderFormBrandType, DownloaderBrandForms } from './downloaderTypes'

const FORM_MAP: DownloaderBrandForms = {
  [BrandFormEnum.STYLE]: DownloaderFormStyle,
  base: DownloaderFormFont,
}

const DownloaderFormBrand: DownloaderFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(DownloaderFormBrand) as typeof DownloaderFormBrand
